import { render, staticRenderFns } from "./SplitGrid.vue?vue&type=template&id=a4677a68&scoped=true&"
import script from "./SplitGrid.vue?vue&type=script&lang=js&"
export * from "./SplitGrid.vue?vue&type=script&lang=js&"
import style0 from "./SplitGrid.vue?vue&type=style&index=0&id=a4677a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4677a68",
  null
  
)

export default component.exports